import { useEffect } from 'react';
import { FlexLayout, InputField } from '@gv/triage-components';
import { useField, FormikValues, useFormikContext } from 'formik';

import { useAppDispatch } from 'store';
import { useShowProtocols } from 'components/cases';
import { useFormEntities } from 'components/cases/form';
import { setIsButtonHide } from 'store/slices/analytics-export';

import * as Styles from './styles';
import { CheckProtocolsInfoProps } from './types';

export const CheckProtocolsInfo = ({
  children,
  hideNotes,
  hideCheckProtocols,
  hospitalType = 'main',
}: CheckProtocolsInfoProps) => {
  const { values } = useFormikContext<FormikValues>();
  const [confirm] = useField('checkProtocolsConfirm');

  const { isMainHospital } = useFormEntities();
  const showProtocols = useShowProtocols(values);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      showProtocols &&
      !hideCheckProtocols &&
      ((!isMainHospital && hospitalType === 'other') ||
        (isMainHospital && hospitalType === 'main'))
    ) {
      dispatch(setIsButtonHide(!confirm.value));
    }
  }, [confirm.value]);

  const notesField =
    hospitalType === 'main' && !hideNotes ? (
      <InputField
        label="Notes"
        placeholder="Add note"
        name="additional_notes"
        type="textarea-autosize"
      />
    ) : null;

  const shouldShowChildren = !!children || !!notesField;
  const shouldShowFullProtocolSection =
    showProtocols &&
    !hideCheckProtocols &&
    ((!isMainHospital && hospitalType === 'other') ||
      (isMainHospital && hospitalType === 'main')) &&
    shouldShowChildren;

  if (shouldShowFullProtocolSection) {
    return (
      <FlexLayout gap={24} flexDirection="column">
        <Styles.ChildrenWrapper disabled={false}>
          {children}
          {notesField}
        </Styles.ChildrenWrapper>
      </FlexLayout>
    );
  }

  // fallback render when conditions don't match
  return (
    <>
      {children}
      {notesField}
    </>
  );
};
